export default __webpack_public_path__ + "static/job2-458abfca183d8e8e714b5c359ca13a06.jpg";